module.exports = __webpack_public_path__ + "img/12.f221e8cb.jpg";